<template>
  <h1>Vaihda salasana</h1>
</template>

<script>
export default {};
</script>

<style></style>
